<template>
  <v-dialog v-model="show" persistent :max-width="maxWidth">
    <template v-slot:activator="{ on }">
      <div v-on="on" :disabled="disabled">
        <slot></slot>
      </div>
    </template>

    <v-card>
      <v-card-title class="headline">{{ question }}</v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12">
            <slot name="message"></slot>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <slot name="options"></slot>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn color="warning" text @click.native="onCloseDialog">No</v-btn>
        <v-btn color="primary" @click="onConfirm">Yes</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "ConfirmationDialog",
  props: {
    item: {
      type: Object,
    },
    showDialog: {
      type: Boolean,
      default: false,
    },
    maxWidth: {
      type: Number,
      default: 290,
    },
    callback: {
      type: Function,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      show: false,
      question: "Are you sure?",
    };
  },
  methods: {
    onConfirm() {
      this.show = false;
      this.$emit("onConfirm", this.item);
      if (this.callback) {
        this.callback();
      }
    },
    onCloseDialog() {
      this.show = false;
      this.$emit("onCloseDialog");
    },
  },
  watch: {
    showDialog(value) {
      this.show = value;
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/shared/ConfirmationDialog.vue